export type CourseStatus = 'ENABLED' | 'DISABLED' | 'LOCKED';

export const COURSE_STATUS: { [key: string]: CourseStatus } = {
  ENABLED: 'ENABLED',
  DISABLED: 'DISABLED',
  LOCKED: 'LOCKED',
};
